

"use strict";
import { oBase, Ilk, oBool, oColor, oCsv, oDaton, oDatim, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd } from "../util/ovars";
import { DIALOG_AUX_FUNCTIONS } from "../util/classes";
import { Whisper } from "../util/classes";
import { UTL } from "../util/classes";
import { TRANS } from "../util/classes";

/**
 * DIALOG5 Static Class
 * מחלקה סטטית לניהול דיאלוג בחירת זמן (שעות ודקות - HoMin)
 */
export class DIALOG5 {
    // --- Components (Static Properties) ---
    public static overlay_element: HTMLElement = null; // must be public need to call from outside
    private static popup_element: HTMLElement = null;
    private static caption_element: HTMLElement = null;
    private static case_element: HTMLElement = null;
    private static d1_element: HTMLElement = null;
    private static d2_element: HTMLElement = null;
    private static d3_element: HTMLElement = null;
    private static d4_element: HTMLElement = null;
    private static colon_element: HTMLElement = null;
    private static close_button_element: HTMLSpanElement = null;
    private static defo_button_element: HTMLSpanElement = null;
    private static panel_element: HTMLElement = null;
    private static ok_button_element: HTMLElement = null;
    private static cancel_button_element: HTMLElement = null;
    private static erase_button_element: HTMLElement = null;

    // --- State Variables ---
    private static MD_FLAG: boolean = false;
    private static defo_button_is_clicked: boolean = false;
    private static Vamod_MouseX: number = 0;
    private static Vamod_MouseY: number = 0;
    private static Vamod_ModalWindowLeftX: number = 0;
    private static Vamod_ModalWindowTopY: number = 0;

    private static par_callback_function: Function = null;
    private static par_input_OBJ: oHomin = null;
    private static par_wisper: Whisper = null;
    private static var_CursorPosition: number = 1;

    private static readonly BID = {
        UNDEFINED: 0,
        OK: 1,
        CANCEL: 2,
        ERASE: 3
    };

    private static var_current_pseudo_focused_btn: number = DIALOG5.BID.OK;

    // --- Methods ---

    public static refresh_pseudo_focus_for_all_buttons(): void {
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG5.ok_button_element, DIALOG5.var_current_pseudo_focused_btn == DIALOG5.BID.OK);
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG5.cancel_button_element, DIALOG5.var_current_pseudo_focused_btn == DIALOG5.BID.CANCEL);
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG5.erase_button_element, DIALOG5.var_current_pseudo_focused_btn == DIALOG5.BID.ERASE);
    }

    public static respond_tab(): void {
        DIALOG5.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Forward(DIALOG5.var_current_pseudo_focused_btn, DIALOG5.BID.OK, DIALOG5.BID.ERASE);
        DIALOG5.refresh_pseudo_focus_for_all_buttons();
    }

    public static respond_shift_tab(): void {
        DIALOG5.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Backward(DIALOG5.var_current_pseudo_focused_btn, DIALOG5.BID.OK, DIALOG5.BID.ERASE);
        DIALOG5.refresh_pseudo_focus_for_all_buttons();
    }

    private static create_overlay_element(): HTMLElement {
        const overlay_element = document.createElement("div");
        overlay_element.style.position = "fixed";
        overlay_element.style.top = "0";
        overlay_element.style.left = "0";
        overlay_element.style.width = "100%";
        overlay_element.style.height = "100%";
        overlay_element.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
        overlay_element.style.zIndex = "1000";
        return overlay_element;
    }

    private static create_popup_element(): HTMLElement {
        const popup_element = document.createElement("div");
        popup_element.id = "id-DIALOG5-popup";
        popup_element.style.position = "absolute";
        popup_element.style.backgroundColor = "#fff";
        popup_element.style.padding = "0px";
        popup_element.style.borderRadius = "8px";
        popup_element.style.width = "320px";
        popup_element.style.textAlign = "center";
        return popup_element;
    }

    private static create_caption_element(): HTMLElement {
        const caption = document.createElement("div");
        caption.textContent = "DIALOG5";
        caption.style.fontSize = "24px";
        caption.style.fontWeight = "bold";
        caption.style.margin = "0px";
        caption.style.padding = "0px";
        caption.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_caption_backgroundColor();
        caption.style.color = DIALOG_AUX_FUNCTIONS.get_caption_forgroundColor();
        caption.style.borderTopLeftRadius = "5px";
        caption.style.borderTopRightRadius = "5px";
        caption.style.userSelect = "none";
        return caption;
    }

    private static create_close_button(): HTMLSpanElement {
        return DIALOG_AUX_FUNCTIONS.create_close_button_element();
    }

    private static create_defo_button(): HTMLSpanElement {
        return DIALOG_AUX_FUNCTIONS.create_defo_button_element();
    }

    private static create_case_element(): HTMLElement {
        const element = document.createElement("div");
        element.id = "id-DIALOG5-case";
        element.style.backgroundColor = "yellow";
        element.style.display = "flex";
        element.style.width = "165px";
        element.style.padding = "2px";
        element.style.margin = "auto";
        return element;
    }

    private static create_new_stit_element(): HTMLElement {
        const element = document.createElement("div");
        element.style.backgroundColor = "white";
        element.style.width = "30px";
        element.style.fontSize = "26px";
        element.style.margin = "1px";
        element.textContent = "X";
        element.style.userSelect = "none";
        return element;
    }

    private static create_new_colon_element(): HTMLElement {
        const element = document.createElement("div");
        element.style.width = "35px";
        element.style.textAlign = "center";
        element.style.backgroundColor = "yellow";
        element.style.fontSize = "26px";
        element.style.margin = "1px";
        element.textContent = ":";
        element.style.userSelect = "none";
        return element;
    }

    private static create_panel_element(): HTMLElement {
        const buttonsContainer = document.createElement("div");
        buttonsContainer.style.marginTop = "15px";
        buttonsContainer.style.display = "flex";
        buttonsContainer.style.justifyContent = "space-around";
        buttonsContainer.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_panel_backgroundColor();
        buttonsContainer.style.marginBottom = "7px";
        return buttonsContainer;
    }

    private static create_ok_button_element(): HTMLElement {
        const element = DIALOG_AUX_FUNCTIONS.create_ok_button_element();
        UTL.MakeElementUnFocusable(element);
        return element;
    }

    private static create_cancel_button_element(): HTMLElement {
        const element = DIALOG_AUX_FUNCTIONS.create_cancel_button_element();
        UTL.MakeElementUnFocusable(element);
        return element;
    }

    private static create_erase_button_element(): HTMLElement {
        const element = DIALOG_AUX_FUNCTIONS.create_erase_button_element();
        UTL.MakeElementUnFocusable(element);
        return element;
    }

    public static overlay_mousedown(event: MouseEvent): void {
        const target_element = event.target as HTMLElement;
        if (target_element == DIALOG5.caption_element) {
            const popup_element_bounding_rect = DIALOG5.popup_element.getBoundingClientRect();
            DIALOG5.MD_FLAG = true;
            DIALOG5.Vamod_MouseX = event.clientX;
            DIALOG5.Vamod_MouseY = event.clientY;
            // התיקון שלמדו ב-DIALOG4: אין צורך ב-parseFloat
            DIALOG5.Vamod_ModalWindowLeftX = popup_element_bounding_rect.left;
            DIALOG5.Vamod_ModalWindowTopY = popup_element_bounding_rect.top;
        }
        if (target_element == DIALOG5.defo_button_element) {
            DIALOG5.defo_button_is_clicked = true;
        }
        if (target_element == DIALOG5.d1_element) {
            DIALOG5.var_CursorPosition = 1;
            DIALOG5.mark_current_digit();
        }
        if (target_element == DIALOG5.d2_element) {
            DIALOG5.var_CursorPosition = 2;
            DIALOG5.mark_current_digit();
        }
        if (target_element == DIALOG5.d3_element) {
            DIALOG5.var_CursorPosition = 3;
            DIALOG5.mark_current_digit();
        }
        if (target_element == DIALOG5.d4_element) {
            DIALOG5.var_CursorPosition = 4;
            DIALOG5.mark_current_digit();
        }
    }

    public static overlay_mousemove(event: MouseEvent): void {
        if (DIALOG5.MD_FLAG == true) {
            const delta_x = event.clientX - DIALOG5.Vamod_MouseX;
            const delta_y = event.clientY - DIALOG5.Vamod_MouseY;
            DIALOG5.popup_element.style.left = (DIALOG5.Vamod_ModalWindowLeftX + delta_x) + "px";
            DIALOG5.popup_element.style.top = (DIALOG5.Vamod_ModalWindowTopY + delta_y) + "px";
        }
    }

    public static overlay_mouseup(event: MouseEvent): void {
        const freezed_defo_button_is_clicked = DIALOG5.defo_button_is_clicked;
        DIALOG5.MD_FLAG = false;
        DIALOG5.defo_button_is_clicked = false;
        if (freezed_defo_button_is_clicked == false) {
            DIALOG5.case_element.focus();
        }
    }

    public static perform_pseudo_focused_button(): void {
        if (DIALOG5.var_current_pseudo_focused_btn == DIALOG5.BID.OK) {
            DIALOG5.perform_ok();
        }
        if (DIALOG5.var_current_pseudo_focused_btn == DIALOG5.BID.CANCEL) {
            DIALOG5.perform_cancel();
        }
        if (DIALOG5.var_current_pseudo_focused_btn == DIALOG5.BID.ERASE) {
            DIALOG5.perform_erase();
        }
    }

    public static overlay_keydown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            DIALOG5.perform_pseudo_focused_button();
        }
        if (event.key === 'Escape') {
            DIALOG5.perform_cancel();
        }
        if (event.key === 'ArrowLeft') {
            event.preventDefault();
            if (DIALOG5.var_CursorPosition > 1) {
                DIALOG5.var_CursorPosition--;
                DIALOG5.mark_current_digit();
            }
        }
        if (event.key === 'ArrowRight') {
            event.preventDefault();
            if (DIALOG5.var_CursorPosition < 4) {
                DIALOG5.var_CursorPosition++;
                DIALOG5.mark_current_digit();
            }
        }
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            event.preventDefault();
        }
        if (event.key === 'Delete') {
            DIALOG5.VK_DELETE();
        }
        if (event.key === 'Backspace') {
            DIALOG5.VK_BACK();
        }
        if (event.key === 'Tab') {
            event.preventDefault();
            if (event.shiftKey == false) DIALOG5.respond_tab();
            if (event.shiftKey == true) DIALOG5.respond_shift_tab();
        }

        if (event.key === ' ') {
            event.preventDefault();
            DIALOG5.put_char_in_digit_element_given_digit_number(DIALOG5.var_CursorPosition, " ");
            if (DIALOG5.var_CursorPosition < 4) { // בקוד המקורי היה רשום 8, תיקנתי ל-4 בהתאם למספר הספרות
                DIALOG5.var_CursorPosition++;
                DIALOG5.mark_current_digit();
            }
            DIALOG5.case_element.focus();
        }

        if (UTL.string_contains_digit(event.key) == true) {
            event.preventDefault();
            const digit_as_number = TRANS.trans_digit_string_to_digit_number(event.key);
            const digit_str = TRANS.trans_digit_number_to_string(digit_as_number);
            DIALOG5.put_char_in_digit_element_given_digit_number(DIALOG5.var_CursorPosition, digit_str);
            if (DIALOG5.var_CursorPosition < 4) {
                DIALOG5.var_CursorPosition++;
                DIALOG5.mark_current_digit();
            }
        }
    }

    private static create_new_br_element(): HTMLBRElement {
        return document.createElement('br');
    }

    public static paint_colors_in_select_elements(element: HTMLElement, bval: boolean): void {
        if (bval == false) {
            element.style.backgroundColor = "white";
            element.style.color = "black";
        }
        if (bval == true) {
            element.style.backgroundColor = "blue";
            element.style.color = "white";
        }
    }


    public static create_dialog(p_callback_function: Function, p_input_OBJ: oHomin, p_wisper: Whisper): void {
        DIALOG5.par_callback_function = p_callback_function;
        DIALOG5.par_input_OBJ = p_input_OBJ;
        DIALOG5.par_wisper = p_wisper;

        DIALOG5.overlay_element = DIALOG5.create_overlay_element();
        DIALOG5.popup_element = DIALOG5.create_popup_element();
        DIALOG5.caption_element = DIALOG5.create_caption_element();
        DIALOG5.close_button_element = DIALOG5.create_close_button();
        DIALOG5.defo_button_element = DIALOG5.create_defo_button();

        DIALOG5.case_element = DIALOG5.create_case_element();
        DIALOG5.d1_element = DIALOG5.create_new_stit_element();
        DIALOG5.d2_element = DIALOG5.create_new_stit_element();
        DIALOG5.d3_element = DIALOG5.create_new_stit_element();
        DIALOG5.d4_element = DIALOG5.create_new_stit_element();
        DIALOG5.colon_element = DIALOG5.create_new_colon_element();

        DIALOG5.panel_element = DIALOG5.create_panel_element();
        DIALOG5.ok_button_element = DIALOG5.create_ok_button_element();
        DIALOG5.cancel_button_element = DIALOG5.create_cancel_button_element();
        DIALOG5.erase_button_element = DIALOG5.create_erase_button_element();

        DIALOG5.overlay_element.appendChild(DIALOG5.popup_element);
        DIALOG5.caption_element.appendChild(DIALOG5.close_button_element);
        DIALOG5.caption_element.appendChild(DIALOG5.defo_button_element);
        DIALOG5.popup_element.appendChild(DIALOG5.caption_element);
        DIALOG5.popup_element.appendChild(DIALOG5.create_new_br_element());

        DIALOG5.popup_element.appendChild(DIALOG5.case_element);
        DIALOG5.case_element.appendChild(DIALOG5.d1_element);
        DIALOG5.case_element.appendChild(DIALOG5.d2_element);
        DIALOG5.case_element.appendChild(DIALOG5.colon_element);
        DIALOG5.case_element.appendChild(DIALOG5.d3_element);
        DIALOG5.case_element.appendChild(DIALOG5.d4_element);

        DIALOG5.popup_element.appendChild(DIALOG5.panel_element);
        DIALOG5.panel_element.appendChild(DIALOG5.ok_button_element);
        DIALOG5.panel_element.appendChild(DIALOG5.cancel_button_element);
        DIALOG5.panel_element.appendChild(DIALOG5.erase_button_element);

        DIALOG5.overlay_element.addEventListener("mousedown", DIALOG5.overlay_mousedown);
        DIALOG5.overlay_element.addEventListener("mousemove", DIALOG5.overlay_mousemove);
        DIALOG5.overlay_element.addEventListener("mouseup", DIALOG5.overlay_mouseup);
        DIALOG5.overlay_element.addEventListener("keydown", DIALOG5.overlay_keydown);

        DIALOG5.defo_button_element.addEventListener("click", DIALOG5.perform_defo);
        DIALOG5.ok_button_element.addEventListener("click", DIALOG5.perform_ok);
        DIALOG5.cancel_button_element.addEventListener("click", DIALOG5.perform_cancel);
        DIALOG5.erase_button_element.addEventListener("click", DIALOG5.perform_erase);
        DIALOG5.close_button_element.addEventListener("click", DIALOG5.perform_cancel);

        document.body.appendChild(DIALOG5.overlay_element);
        UTL.center_popup_element_inside_overlay_element(DIALOG5.popup_element, DIALOG5.overlay_element);

        DIALOG5.var_current_pseudo_focused_btn = DIALOG5.BID.OK;
        DIALOG5.refresh_pseudo_focus_for_all_buttons();
        DIALOG5.var_CursorPosition = 1;
        DIALOG5.mark_current_digit();
        UTL.MakeElementFocusable(DIALOG5.case_element);

        DIALOG5.SetDigitsBy_par_homin();
        DIALOG5.case_element.focus();
    }

    public static trans_digit_number_to_digit_elemenet(digit_number: number): HTMLElement {
        if (digit_number == 1) return DIALOG5.d1_element;
        if (digit_number == 2) return DIALOG5.d2_element;
        if (digit_number == 3) return DIALOG5.d3_element;
        if (digit_number == 4) return DIALOG5.d4_element;
        return null;
    }

    public static trans_digit_elemenet_to_digit_number(digit_element: HTMLElement): number {
        if (digit_element == DIALOG5.d1_element) return 1;
        if (digit_element == DIALOG5.d2_element) return 2;
        if (digit_element == DIALOG5.d3_element) return 3;
        if (digit_element == DIALOG5.d4_element) return 4;
        return null;
    }

    public static mark_current_digit(): void {
        for (let digit_number = 1; digit_number <= 4; digit_number++) {
            let digit_element: HTMLElement = DIALOG5.trans_digit_number_to_digit_elemenet(digit_number);
            if (digit_element === null) continue;

            if (digit_number == DIALOG5.var_CursorPosition) {
                digit_element.style.color = "white";
                digit_element.style.backgroundColor = "blue";
            } else {
                digit_element.style.color = "black";
                digit_element.style.backgroundColor = "white";
            }
        }
    }

    public static put_char_in_digit_element_given_digit_number(p_digit_number: number, p_digit_as_str: string): void {
        let digit_element = DIALOG5.trans_digit_number_to_digit_elemenet(p_digit_number);
        if (digit_element === null) return;
        digit_element.textContent = p_digit_as_str;
    }

    public static PutDigit(p_digit_number: number, p_digit_as_number: number): void {
        if (p_digit_as_number != -1) {
            const digit_as_str = p_digit_as_number.toString();
            DIALOG5.put_char_in_digit_element_given_digit_number(p_digit_number, digit_as_str);
        } else {
            DIALOG5.put_char_in_digit_element_given_digit_number(p_digit_number, " ");
        }
    }

    public static erase_all_digits(): void {
        for (let digit_number = 1; digit_number <= 4; digit_number++) {
            DIALOG5.put_char_in_digit_element_given_digit_number(digit_number, ' ');
        }
    }

    public static SetDigitsBy_par_homin(): void {
        if (DIALOG5.par_input_OBJ.OBJ_EXIST == false) {
            DIALOG5.erase_all_digits();
        } else {
            const homin = DIALOG5.par_input_OBJ.NUMBER_CONTENT;
            const hour = UTL.GET_HOMIN_HOUR(homin);
            const min = UTL.GET_HOMIN_MIN(homin);
            const d1 = TRANS.trans_number_and_position_to_digit_as_int(hour, 1);
            const d2 = TRANS.trans_number_and_position_to_digit_as_int(hour, 0);
            const d3 = TRANS.trans_number_and_position_to_digit_as_int(min, 1);
            const d4 = TRANS.trans_number_and_position_to_digit_as_int(min, 0);
            DIALOG5.PutDigit(1, d1);
            DIALOG5.PutDigit(2, d2);
            DIALOG5.PutDigit(3, d3);
            DIALOG5.PutDigit(4, d4);
        }
    }

    public static GetDigit(digit_number: number): number {
        const digit_element = DIALOG5.trans_digit_number_to_digit_elemenet(digit_number);
        if (digit_element === null) return -1;

        const digit_str = digit_element.textContent;
        if (!digit_str || digit_str.trim().length == 0) {
            return -1;
        }
        return TRANS.trans_digit_string_to_digit_number(digit_str);
    }

    public static decode_HOUR(): number {
        const d1 = DIALOG5.GetDigit(1);
        const d2 = DIALOG5.GetDigit(2);
        if (d1 == -1 && d2 == -1) return -1;

        let sum = 0;
        if (d1 != -1) sum = sum * 10 + d1;
        if (d2 != -1) sum = sum * 10 + d2;
        return sum;
    }

    public static decode_MIN(): number {
        const d3 = DIALOG5.GetDigit(3);
        const d4 = DIALOG5.GetDigit(4);
        if (d3 == -1 && d4 == -1) return -1;

        let sum = 0;
        if (d3 != -1) sum = sum * 10 + d3;
        if (d4 != -1) sum = sum * 10 + d4;
        return sum;
    }

    public static decode_homin(): number {
        const min = DIALOG5.decode_MIN();
        const hour = DIALOG5.decode_HOUR();
        if (hour == -1 && min == -1) return -1;
        return UTL.MAKE_HOMIN(hour, min);
    }

    public static create_result_OBJ(p_value_exist: boolean, p_value_conent: number): oHomin {
        const CONSTRUCTIOR = Object.getPrototypeOf(DIALOG5.par_input_OBJ).constructor;
        if (CONSTRUCTIOR === oHomin) {
            return new oHomin(p_value_exist, p_value_conent);
        }
        alert("DIALOG5.error unknown object");
    }

    public static call_callback(p_change_flag: boolean, p_value_exist: boolean, p_value_conent: number): void {
        if (DIALOG5.par_callback_function != null) {
            document.body.removeChild(DIALOG5.overlay_element);
            let OBJ = DIALOG5.create_result_OBJ(p_value_exist, p_value_conent);
            setTimeout(DIALOG5.par_callback_function, 0, p_change_flag, OBJ);
        } else {
            alert("DIALOG5_callback_function != null");
        }
    }

    public static perform_ok(): void {
        const change_flag = true;
        const value_exist = true;
        const value_content = DIALOG5.decode_homin();
        DIALOG5.call_callback(change_flag, value_exist, value_content);
    }

    public static perform_defo(): void {
        UTL.show_which_element_has_focus();
    }

    public static perform_cancel(): void {
        DIALOG5.call_callback(false, false, -1);
    }

    public static perform_erase(): void {
        // המימוש המקורי שלך כלל רק הצגת פוקוס
        UTL.show_which_element_has_focus();
        // הערה: אם תרצה לממש מחיקה מלאה, השתמש ב-call_callback עם value_exist = false
    }

    public static VK_DELETE(): void {
        const FreezedCursor = DIALOG5.var_CursorPosition;
        if (FreezedCursor === 1) {
            DIALOG5.PutDigit(1, DIALOG5.GetDigit(2));
            DIALOG5.PutDigit(2, -1);
        }
        if (FreezedCursor === 2) {
            DIALOG5.PutDigit(2, -1);
        }
        if (FreezedCursor === 3) {
            DIALOG5.PutDigit(3, DIALOG5.GetDigit(4));
            DIALOG5.PutDigit(4, -1);
        }
        if (FreezedCursor === 4) {
            DIALOG5.PutDigit(4, -1);
        }
    }

    public static VK_BACK(): void {
        const FreezedCursor = DIALOG5.var_CursorPosition;
        if (FreezedCursor === 1) {
            DIALOG5.PutDigit(1, -1);
            DIALOG5.VK_DELETE();
            DIALOG5.mark_current_digit();
        }
        if (FreezedCursor === 2) {
            DIALOG5.var_CursorPosition -= 1;
            DIALOG5.VK_DELETE();
            DIALOG5.mark_current_digit();
        }
        if (FreezedCursor === 3) {
            DIALOG5.PutDigit(3, -1);
            DIALOG5.var_CursorPosition -= 1;
            DIALOG5.mark_current_digit();
        }
        if (FreezedCursor === 4) {
            DIALOG5.var_CursorPosition -= 1;
            DIALOG5.VK_DELETE();
            DIALOG5.mark_current_digit();
        }
    }
}


